/*
 * ELEMENTO — Industry Insider status block, trade discount-code guard, cart drawer presentation.
 *
 * Totals and the "Taxes and shipping calculated at checkout" line render from Liquid in
 * templates/cart.ajax.liquid. The only DOM this file moves is the terms line, which is
 * emitted by something outside that template.
 */

/*
 * theme.liquid declares:  const customerTags = {{ customer.tags | json }};
 * A top-level `const` is a LEXICAL binding — it never lands on `window`. Read the bare
 * identifier through the scope chain, guarded by typeof for logged-out visitors.
 */
function ebCustomerTags() {
  try {
    if (typeof customerTags !== "undefined" && Array.isArray(customerTags)) {
      return customerTags;
    }
  } catch (e) { /* not declared */ }

  if (Array.isArray(window.customerTags)) return window.customerTags;
  return [];
}

function ebIsTradeMember() {
  return ebCustomerTags().indexOf("Trade Member") !== -1;
}

/* ------------------------------------------------------------------
   Industry Insider account status block
   ------------------------------------------------------------------ */
document.addEventListener("DOMContentLoaded", function () {
  var host = document.querySelector("#chMfFields");
  if (!host) return;

  var box = document.createElement("div");
  box.id = "cs-in-container";
  box.innerHTML =
    '<p class="cs-in-heading">INDUSTRY INSIDER ACCOUNT STATUS:</p>' +
    '<p class="cs-in-text">INDUSTRY INSIDER ACCOUNT NOT ACTIVATED</p>' +
    '<a class="cs-in-btn btn" href="https://elementobath.com/pages/trade#TradeForm">APPLY NOW</a>';
  host.appendChild(box);

  var text = box.querySelector(".cs-in-text");
  var btn = box.querySelector(".cs-in-btn");
  var tags = ebCustomerTags();

  if (text && btn) {
    if (tags.indexOf("Trade Member") !== -1) {
      btn.remove();
      text.textContent = "INDUSTRY INSIDER ACCOUNT ACTIVATED";
    } else if (tags.indexOf("Trade Applicant") !== -1) {
      btn.remove();
      text.textContent = "APPLICATION UNDER REVIEW";
    }
  }
});

/* ------------------------------------------------------------------
   Trade members carry no discount codes.
   POST /cart/update.js with { discount: '' } clears all codes (Cart AJAX API, May 2025).
   ------------------------------------------------------------------ */
(function () {
  if (!ebIsTradeMember()) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  fetch(root + "cart.js", { credentials: "same-origin" })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      if (!cart || !cart.discount_codes || cart.discount_codes.length === 0) return;

      return fetch(root + "cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: "" })
      }).then(function () {
        window.location.reload();
      });
    })
    .catch(function () { /* leave the cart alone if anything fails */ });
})();

/* ------------------------------------------------------------------
   Drawer presentation.
   ------------------------------------------------------------------ */
(function () {
  var SYMBOLS = {
    CAD: "CA$", AUD: "AU$", NZD: "NZ$",
    HKD: "HK$", SGD: "SG$", MXN: "MX$", TWD: "NT$"
  };

  var TERMS_RE = /By placing this order/i;

  function injectCss() {
    if (document.getElementById("eb-cart-totals-css")) return;
    var style = document.createElement("style");
    style.id = "eb-cart-totals-css";

    /*
     * drawer-cart.liquid rule 8 is:
     *   #CartDrawer .drawer__footer > p.text-small.rte { display:none !important; }
     * specificity (1,3,1). Once the terms paragraph is moved into the footer as a direct
     * child, that rule hides it. !important does not break the tie — specificity does. The
     * `.eb-terms-moved` selector is repeated three times to reach (1,4,1) and win.
     */
    style.textContent = [
      "#CartDrawer .cs-subtotal-dc{display:none !important;}",
      "#CartDrawer .cart_savings-wrapper{display:none !important;}",
      "#CartDrawer .cart__subtotal-wrapper{display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:5px 0;}",
      "#CartDrawer .cart__subtotal{font-family:'Neue Haas Unica','Helvetica Neue',sans-serif !important;font-size:14px !important;font-weight:300 !important;letter-spacing:.7px !important;text-transform:uppercase !important;}",
      "#CartDrawer .cart__subtotal-price .cart__subtotal{white-space:nowrap;text-align:right;}",
      "#CartDrawer [data-cart-total],#CartDrawer [data-cart-total] .money{font-weight:400 !important;}",
      "#CartDrawer .price-b2b .text-money,#CartDrawer .price-b2b .text-money *{font-family:'Neue Haas Unica','Helvetica Neue',sans-serif !important;font-weight:300 !important;letter-spacing:.7px !important;text-transform:uppercase !important;font-size:13px !important;}",
      "#CartDrawer .drawer__footer{display:block !important;flex-shrink:0 !important;}",
      "#CartDrawer .drawer__footer .btn--checkout{width:100% !important;}",
      "#CartDrawer .eb-taxes-line{display:block;width:100%;box-sizing:border-box;text-align:center;font-family:'Neue Haas Unica','Helvetica Neue',sans-serif;font-size:11px;font-weight:300;letter-spacing:.4px;text-transform:none;color:#4a4a4a;margin:0 0 10px;padding:0 4px;}",
      "#CartDrawer .drawer__footer .eb-terms-moved.eb-terms-moved.eb-terms-moved{display:block !important;visibility:visible !important;opacity:1 !important;float:none !important;position:static !important;top:auto !important;right:auto !important;left:auto !important;width:100% !important;max-width:100% !important;height:auto !important;box-sizing:border-box !important;text-align:center !important;font-family:'Neue Haas Unica','Helvetica Neue',sans-serif !important;font-size:11px !important;font-weight:300 !important;letter-spacing:.4px !important;text-transform:none !important;color:#4a4a4a !important;margin:12px 0 0 !important;padding:0 4px !important;}",
      "#CartDrawer .cs-totalcart-hidden{display:none !important;}"
    ].join("");
    document.head.appendChild(style);
  }

  function currencySymbol() {
    var active = (window.Shopify && Shopify.currency && Shopify.currency.active) || "";
    return SYMBOLS[active] || null;
  }

  function prefixLooseDollars(drawer, symbol) {
    var walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    var pending = [];
    var node;
    while ((node = walker.nextNode())) {
      if (/\$\d/.test(node.nodeValue) && node.nodeValue.indexOf(symbol) === -1) {
        pending.push(node);
      }
    }
    pending.forEach(function (n) {
      n.nodeValue = n.nodeValue.replace(/(^|[^A-Za-z])\$(\d)/g, function (_, before, digit) {
        return before + symbol + digit;
      });
    });
  }

  /*
   * "By placing this order, you agree to the terms of service." is emitted by something
   * outside templates/cart.ajax.liquid and dropped OUTSIDE the footer (as a sibling of the
   * cart form in the `.flex full` wrapper), which pushes it to the drawer's top-right.
   *
   * Move it INSIDE `.drawer__footer`, directly after the checkout button, where the
   * `#CartDrawer .drawer__footer .eb-terms-moved` rule centres it under the button.
   *
   * NOTE: the paragraph contains an inline "terms of service" <a>, so we must NOT require a
   * childless element (the previous `el.children.length !== 0` guard is exactly why it was
   * never moved). Instead we take the DEEPEST element that contains the phrase — the
   * paragraph itself, not a wrapper that merely encloses it.
   */
  function relocateTerms(drawer) {
    var footer = drawer.querySelector(".drawer__footer");
    if (!footer) return;

    var checkout = footer.querySelector(".btn--checkout");
    if (!checkout) return;

    // Already relocated: keep it inside the footer, immediately after the checkout button.
    var existing = document.querySelector(".eb-terms-moved");
    if (existing) {
      if (existing.parentNode !== footer || existing.previousElementSibling !== checkout) {
        checkout.insertAdjacentElement("afterend", existing);
      }
      return;
    }

    var candidates = document.querySelectorAll("p, div, span, small, label");
    var match = null;
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!TERMS_RE.test(el.textContent || "")) continue;
      if (el.closest(".eb-taxes-line")) continue;
      if (el.classList.contains("btn--checkout")) continue;

      // Take the innermost matching element: skip if a descendant also holds the phrase.
      var deeper = false;
      var kids = el.querySelectorAll("p, div, span, small, label");
      for (var k = 0; k < kids.length; k++) {
        if (TERMS_RE.test(kids[k].textContent || "")) { deeper = true; break; }
      }
      if (deeper) continue;

      match = el;
      break;
    }
    if (!match) return;

    match.classList.add("eb-terms-moved");
    checkout.insertAdjacentElement("afterend", match);
  }

  function render() {
    var drawer = document.querySelector("#CartDrawer");
    if (!drawer) return;

    injectCss();

    var symbol = currencySymbol();
    if (symbol) prefixLooseDollars(drawer, symbol);

    relocateTerms(drawer);
  }

  var debounce;
  if (document.readyState !== "loading") {
    render();
  } else {
    document.addEventListener("DOMContentLoaded", render);
  }

  new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(render, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();